<template>
  <div>
    <Pos_debt_balance_pay_history/>
  </div>
</template>

<script>
import Pos_debt_balance_pay_history from "@/components/adminArin/pos_system/product/Pos_debt_balance_pay_history";
export default {
  name: "PosDebtBalancePayHistory",
  components: {
    Pos_debt_balance_pay_history
  }
}
</script>

<style scoped>

</style>
